<template lang="pug">
el-dialog(width="650px", :visible.sync="visible", :close-on-click-modal="false", @closed="reject")
  template(#title)
    span.el-dialog__title 选择目录
    el-select(v-model="moduleId", size="small", placeholder="项目类型", @change="queryTree")
      el-option(v-for="item in moduleList", :key="item.dicId", :label="item.cnName", :value="item.dicId")
  el-tree(
    ref="tree",
    :data="tableData",
    :props="treeProp",
    :default-checked-keys="defaultIds",
    :default-expanded-keys="defaultIds",
    show-checkbox,
    node-key="folderId",
    check-strictly,
    auto-expand-parent,
    expand-on-click-node,
    @check="setCheckFolder"
  )
    template(#default="{ data }")
      .node
        FileIcon.node-icon(:row="data", :icon-size="20")
        FileName(:name="data.folderName")
  template(#footer)
    el-button(@click="close()") 取消
    el-button(type="primary", @click="submit()") 确定
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import dicService from "@/CommonDP/service/dic-service";
import folderTemplateService from "@/CommonDP/service/admin/folderTemplate-service";
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import FileName from "@/CommonDP/components/FileList/fileName.vue";
export default {
  components: { FileIcon, FileName },
  mixins: [asyncMixin],
  data() {
    return {
      folders: [],
      defaultIds: [],
      visible: false,
      moduleList: [],
      moduleId: "",
      tableData: [],
      treeProp: {
        children: "childrenList",
        value: "folderId",
        label: "folderName"
      }
    };
  },
  created() {
    this.getModuleList();
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    submit() {
      const moduleId = this.moduleId;
      const data = this.$refs.tree.getCheckedNodes();
      const [vo] = data;
      const paths = [];
      if (vo) {
        let node = this.$refs.tree.getNode(vo);
        while (node && node.data && node.data.folderId) {
          const { folderId, folderName } = node.data;
          paths.unshift({ folderId, folderName, moduleId });
          node = node.parent;
        }
      }
      this.resolve({ paths });
      this.visible = false;
    },
    setCheckFolder(data, { checkedKeys }) {
      if (checkedKeys[0]) {
        this.$refs.tree.setCheckedKeys([data.folderId]);
      }
    },
    async getModuleList() {
      const { data } = await dicService.getDicList("folderTemplateType");
      this.moduleList = data || [];
      this.moduleId ||= data?.[0]?.dicId;
      await this.queryTree();
    },
    async queryTree() {
      const { data } = await folderTemplateService.queryFolderTemplateTree(this.moduleId);
      const list = [...data];
      for (const vo of list) {
        vo.isFolder = 1;
        vo.childrenList && list.push(...vo.childrenList);
      }
      this.visible = true;
      this.tableData = data;
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss">
</style>
